import { ChangeDetectorRef, Component, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { debounceTime, distinct, distinctUntilChanged, interval, map, Subscription, tap } from 'rxjs';
import { JobsService } from 'src/app/core/services/jobs.service';
import { NavigationService } from 'src/app/core/services/navigation.service';
import { SyncConfigService } from 'src/app/core/services/sync-config.service';

@Component({
  selector: 'app-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.scss']
})
export class SummaryComponent implements OnInit {
  @ViewChild(MatSort, { static: false }) set content(sort: MatSort) {
    this.activeJobs.sort = sort;
  };
  activeJobs: MatTableDataSource<any> = new MatTableDataSource([]);
  depName: string =
    this.route.snapshot.params['deploymentName'] ||
    this.route.parent.snapshot.params['deploymentName'];
  filterText = new FormControl('');
  displayedColumns: string[] = [];
  noDataMsg: string = '';
  dataReloadSubscription: Subscription;

  constructor(
    private navService: NavigationService,
    private route: ActivatedRoute,
    private jobService: JobsService,
    private spinner: NgxSpinnerService,
    private syncConfig: SyncConfigService
  ) { }

  ngOnInit(): void {
    this.spinner.show("jobSummary");
    this.navService.sendParentData('Queue');
    this.navService.sendLeftPanelIndex(1);
    this.getSummary();
    const intervalMs = this.syncConfig.config?.jobs?.statusReqInterval;
    if (intervalMs && intervalMs > 0) {
      this.dataReloadSubscription = interval(intervalMs).subscribe(() => {
        this.getSummary();
      });
    }
    this.filterText.valueChanges
      .pipe(distinctUntilChanged(), debounceTime(300))
      .subscribe((value) => {
        this.applyFilter(value);
      })
  }

  ngOnDestroy(): void {
    if (this.dataReloadSubscription) {
      this.dataReloadSubscription.unsubscribe();
    }
  }

  getColumns(): string[] {
    return this.activeJobs.data?.length > 0 ? Object.keys(this.activeJobs.data[0]) : [];
  }

  getSummary() {
    this.jobService.getActiveJobSummary(this.depName).pipe(
      tap(() => this.spinner.hide("jobSummary")),
      map((response: any) => {
        // Handle the response - it should now be an array directly
        let data = Array.isArray(response) ? response : [];

        if (!data || data.length === 0) {
          this.noDataMsg = 'No active jobs found';
          return [];
        }

        return data.sort((x, y) => (y.Id|| 0) - (x.Id  || 0));
      })
    ).subscribe({
      next: (sortedData: any[]) => {
        this.activeJobs = new MatTableDataSource(sortedData);
        this.displayedColumns = this.getColumns();
      },
      error: (error) => {
        console.error('Error fetching job summary:', error);
        this.noDataMsg = 'Error loading job data';
        this.spinner.hide("jobSummary");
      }
    });
  }

  applyFilter(value: string) {
    const filterValue = value;
    this.activeJobs.filter = filterValue.trim().toLowerCase();
  }

  refresh(){
    this.noDataMsg = '';
    this.spinner.show("jobSummary");
    this.getSummary();
  }

  isCommaSeparated(value: any) {
    if (typeof value === 'string') {
      return value && value.includes(',');
    }
    return false;
  }
}
